import styled from 'styled-components'
import { cyberColors } from '../../lib/colors'
interface HightLight_Styled_props {
  fontSize: string
  background: 'red' | 'green' | 'blue' | 'grey' | string
  margin?: string
}
interface Text_Styled_Props {
  margin?: string
}
export const Main = styled.main`
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 20px 0;
  height: 540px;
  transition: all 0.333s linear;
`
export const HightLight = styled.p<HightLight_Styled_props>`
  font-size: ${({ fontSize }) => fontSize};
  text-transform: uppercase;
  text-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25);
  background: ${({ background }) =>
    background === 'green'
      ? cyberColors.greenGradient
      : background === 'red'
      ? cyberColors.redGradient
      : background === 'blue'
      ? cyberColors.blueGradient
      : cyberColors.greyText};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  clip-path: inset(1px 0.5px);
  margin: ${({ margin }) => margin};
  display: inline-block;
`
export const Text = styled.div<Text_Styled_Props>`
  text-transform: uppercase;
  font-size: 18px;
  color: ${cyberColors.greyText};
  line-height: 25px;
  margin: ${({ margin }) => margin};
  span {
    color: #979bab;
  }
  svg {
    margin: 0 5px;
    vertical-align: middle;
  }
`
